import { HTMLAttributes, PropsWithChildren } from 'react';
import { colSpan, colStart, ColSpan, ColOffset } from './Grid.styles';

interface ColOwnProps {
  /** Default span (all breakpoints). Defaults to 12 (full width) if no breakpoint props given. */
  xs?: ColSpan;
  sm?: ColSpan;
  md?: ColSpan;
  ml?: ColSpan;
  lg?: ColSpan;
  xl?: ColSpan;
  /** Equivalent to Bootstrap offset-* — skips n columns by shifting col-start */
  offsetXs?: ColOffset;
  offsetSm?: ColOffset;
  offsetMd?: ColOffset;
  offsetMl?: ColOffset;
  offsetLg?: ColOffset;
  offsetXl?: ColOffset;
  tag?: 'div' | 'section' | 'article' | 'aside' | 'ul' | 'li';
}

type ColProps = ColOwnProps & HTMLAttributes<HTMLElement>;

export const Col = ({
  xs,
  sm,
  md,
  ml,
  lg,
  xl,
  offsetXs,
  offsetSm,
  offsetMd,
  offsetMl,
  offsetLg,
  offsetXl,
  className,
  tag = 'div',
  children,
  ...rest
}: ColProps & PropsWithChildren) => {
  const Tag = tag;

  const classes = [
    xs ? colSpan.xs[xs] : 'col-span-12',
    sm && colSpan.sm[sm],
    md && colSpan.md[md],
    ml && colSpan.ml[ml],
    lg && colSpan.lg[lg],
    xl && colSpan.xl[xl],
    offsetXs && colStart.xs[offsetXs],
    offsetSm && colStart.sm[offsetSm],
    offsetMd && colStart.md[offsetMd],
    offsetMl && colStart.ml[offsetMl],
    offsetLg && colStart.lg[offsetLg],
    offsetXl && colStart.xl[offsetXl],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
};
